import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import BrandMark from './BrandMark';
import { neveroverpayApi } from './neveroverpayApi';
import { openPlaidLink, savedPlaidLinkToken } from './plaidLink';
import './neveroverpay.css';

export default function NeverOverpayPlaidOAuth() {
  const navigate = useNavigate();
  const [status, setStatus] = useState('Returning from your bank…');
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        await neveroverpayApi.grantConsent('bank_match');
        const stored = savedPlaidLinkToken();
        const tokenRow = stored ? { link_token: stored } : await neveroverpayApi.plaidLinkToken();
        const publicToken = await openPlaidLink({
          linkToken: tokenRow.link_token,
          receivedRedirectUri: window.location.href,
        });
        if (cancelled) return;
        if (!publicToken) {
          setError('Bank connect was cancelled.');
          return;
        }
        await neveroverpayApi.plaidExchange(publicToken);
        setStatus('Bank connected. Continuing setup…');
        setTimeout(() => navigate('/onboarding'), 800);
      } catch (err) {
        if (!cancelled) setError(err.message || 'Bank connect failed');
      }
    })();
    return () => { cancelled = true; };
  }, [navigate]);

  return (
    <div className="np-root">
      <div className="np-wrap" style={{ paddingTop: 48, maxWidth: 640 }}>
        <BrandMark to="/app" kicker="Bank" />
        <h1 style={{ fontSize: 28, margin: '24px 0 12px' }}>{error ? 'Could not connect bank' : status}</h1>
        {error ? <div className="np-error">{error}</div> : null}
        <p style={{ marginTop: 20 }}><Link className="np-btn ghost" to="/onboarding">Back to setup</Link></p>
      </div>
    </div>
  );
}
